function directionsInit() {
  if (document.documentElement.clientWidth < 1024) {
    let directionsCards = document.querySelector('.directions__cards');

    const swiper = new Swiper(directionsCards, {
      slidesPerView: 3,
      spaceBetween: 20,

      pagination: {
        el: '.directions__cards .swiper-pagination',
      },

      breakpoints: {
        // when window width is >= 0px
        0: {
          slidesPerView: 1,
          spaceBetween: 14,
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });
  }
}

export { directionsInit }